module.exports = __webpack_public_path__ + "static/media/logo-ab-ramonage.e4d40368.svg";